import { SessionDataManager } from './session-data-manager';
import { SESSION_DB_NAME, SESSION_DB_VERSION } from './constants';

/** Main-thread IndexedDB access (blocks + manifest). The workers open the same DB with the same version. */
export const sessionDataManager = new SessionDataManager({ dbName: SESSION_DB_NAME, version: SESSION_DB_VERSION });
